import { useMutation } from '@tanstack/react-query';
import { apiUserAccount } from 'services/api/ApiService';
import { handleApiError } from 'components/ErrorHandler';

export const useGetCep = () => {
  const fetchCep = async (cep: string): Promise<any> => {
    const cepNormalize = cep.replace('-', '').replace('_', '');
    
    if (cepNormalize.length !== 8 || cep === '') {
      throw new Error('CEP inválido');
    }
    
    try {
      const data = await apiUserAccount.get(`/services/address/${cepNormalize}`) as any;
      
      if (!data.cep) {
        throw new Error('CEP não encontrado');
      }
      
      return data;
    } catch (error: any) {
      handleApiError(error, 'CEP não encontrado');
      throw error;
    }
  };
  
  return useMutation({
    mutationFn: fetchCep
  });
};
